import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCustomer,
  getParam,
  getMaterial,
  postApproval,
  postFile,
  getFile,
  updateDraft,
} from "./nonRefAPI";

const initialState = {
  data: [],
  dataMaterial: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  reasonParam: [],
  salesDivisionParam: [],
  distributionChannelParam: [],
  customerData: [],
  approval: [],
  uploadFileId: null,
  reason: null,
  draft: [],
};

export const fetchCustomer = createAsyncThunk(
  "nonRef/fetchCustomer",
  async (payload) => {
    const response = await getCustomer(payload);
    return response.data;
  }
);

export const fetchMaterial = createAsyncThunk(
  "nonRef/fetchMaterial",
  async (payload) => {
    const response = await getMaterial(payload);
    return response.data;
  }
);

export const updateReasonParam = createAsyncThunk(
  "reportHeader/updateReasonParam",
  async (payload) => {
    return payload;
  }
);

export const fetchReasonParam = createAsyncThunk(
  "nonRef/fetchReasonParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);
export const updateSalesDivisionParam = createAsyncThunk(
  "reportHeader/updateSalesDivisionParam",
  async (payload) => {
    return payload;
  }
);

export const fetchSalesDivisionParam = createAsyncThunk(
  "nonRef/fetchSalesDivisionParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const updateDistributionChannelParam = createAsyncThunk(
  "reportHeader/updateDistributionChannelParam",
  async (payload) => {
    return payload;
  }
);

export const fetchDistributionChannelParam = createAsyncThunk(
  "nonRef/fetchDistributionChannelParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const createApproval = createAsyncThunk(
  "qaho/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response.data;
  }
);

export const uploadFile = createAsyncThunk(
  "nonRef/uploadFile",
  async ({ file }) => {
    const response = await postFile(file);
    return response.data;
  }
);

export const getAttachmentId = createAsyncThunk(
  "nonRef/getAttachmentId",
  async (payload) => {
    const response = await getFile(payload);
    return response.data;
  }
);

export const editDraft = createAsyncThunk(
  "nonRef/editDraft",
  async ({ params, id }) => {
    const response = await updateDraft(params, id);
    console.log(params, id);
    return response.data;
  }
);

export const nonRefSlice = createSlice({
  name: "nonRef",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
    setReason: (state, action) => {
      state.reason = action.payload;
    },
    setDraft: (state, action) => {
      state.draft = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.dataMaterial = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })

      .addCase(updateReasonParam.fulfilled, (state, action) => {
        state.reasonParam = action.payload;
      })
      .addCase(fetchReasonParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReasonParam.fulfilled, (state, action) => {
        state.loading = false;
        state.reasonParam = action.payload.data;
      })
      .addCase(updateSalesDivisionParam.fulfilled, (state, action) => {
        state.salesDivisionParam = action.payload;
      })
      .addCase(fetchSalesDivisionParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalesDivisionParam.fulfilled, (state, action) => {
        state.loading = false;
        state.salesDivisionParam = action.payload.data;
      })
      .addCase(updateDistributionChannelParam.fulfilled, (state, action) => {
        state.distributionChannelParam = action.payload;
      })
      .addCase(fetchDistributionChannelParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDistributionChannelParam.fulfilled, (state, action) => {
        state.loading = false;
        state.distributionChannelParam = action.payload.data;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadFileId = action.payload.data;
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(editDraft.pending, (state) => {
        state.loading = true;
      })
      .addCase(editDraft.fulfilled, (state, action) => {
        state.loading = false;
        state.updateR = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setApproval,
  setReason,
  setDraft,
} = nonRefSlice.actions;

export const selectData = (state) => state.nonRef.data;
export const selectDataMaterial = (state) => state.nonRef.dataMaterial;
export const selectLoading = (state) => state.nonRef.loading;
export const selectError = (state) => state.nonRef.error;
export const selectPageNo = (state) => state.nonRef.pageNo;
export const selectPageSize = (state) => state.nonRef.pageSize;
export const selectTotalRecord = (state) => state.nonRef.totalRecord;
export const selectSelected = (state) => state.nonRef.reason;
export const selectReason = (state) => state.nonRef.selected;
export const selectApproval = (state) => state.nonRef.approval;
export const selectReasonParam = (state) => state.nonRef.reasonParam;
export const selectSalesDivisionParam = (state) =>
  state.nonRef.salesDivisionParam;
export const selectDistributionChannelParam = (state) =>
  state.nonRef.distributionChannelParam;
export const selectUploadFileId = (state) => state.nonRef.uploadFileId;
export const selectDraft = (state) => state.nonRef.draft;

export default nonRefSlice.reducer;
